import React from "react";
import Counter from "./Counter";
import {
  prop,
  asDescriptor,
  fromGenerator,
  Hookable,
  asFunctional,
} from "./hookable";

const App = () => {
  return (
    <div className="App">
      <Counter initialCount={100} />
    </div>
  );
};

export default App;
